import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = (props) => {
  const data = {
    labels: ['Progress'],
    datasets: [
      {
        data: [props.data, 100 - props.data], // 70% progress
        backgroundColor: ['#36A2EB', '#E0E0E0'], // Progress color and remaining color
        hoverBackgroundColor: ['#36A2EB', '#E0E0E0'],
      },
    ],
  };

  const options = {
    responsive: true,
    // cutout: '80%', // Adjust the size of the hole
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div style={{ position: 'relative', width: '106px', height:"106px" }}>
      <Doughnut data={data} options={options} />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <h2>{ props.data }</h2>
      </div>
    </div>
  );
};

export default DoughnutChart;